import { PROD } from './stage'

export const ALLOWED_PRODUCTION_ORGANIZATION_ID = '4bf6fcb7-748b-4ccb-9c04-ad77fec1ea9e'

type GetProductionOrganizationAccessErrorParams = {
  stage?: string
  organizationId?: string
}

export const getProductionOrganizationAccessError = ({
  stage,
  organizationId,
}: GetProductionOrganizationAccessErrorParams): string | undefined => {
  if (stage !== PROD) return undefined
  if (organizationId === ALLOWED_PRODUCTION_ORGANIZATION_ID) return undefined
  if (!organizationId) {
    return `This production deployment is only available for organization ${ALLOWED_PRODUCTION_ORGANIZATION_ID}, but the signed-in organization could not be determined.`
  }
  return `This production deployment is only available for organization ${ALLOWED_PRODUCTION_ORGANIZATION_ID}. You are signed in to organization ${organizationId}.`
}
